import React, { useEffect, useRef, useState } from "react";
import Loaders from "../Loaders";
import HeaderTop from "../HeaderTop";
import Menus from "../Menus";
import Footers from "../Footers";
import "../../../libs/css/bootstrap.min3.3.7.css";
import "../../../libs/css/sweetalert2.min.css";
import { API_ROUTES } from "../../../utils/constants";

import Nulls from "../Nulls";
import ServicesTable from "./ServicesTable";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { useForm } from "react-hook-form";

export default function Services(props) {
  const {
    objectToFormData,
    errorFunction,
    Helmet,
    capitalizeWords,
    isAuthExpired,
    getRandomThreeDigitNumber,
    allCPs,
    isLoading1,
  } = props;
  console.log("cps", allCPs);
  useEffect(() => {
    document.title = "Service List | Ringo";
  }, []);

  const {
    register,
    watch,
    getValues,
    setValue,
    reset,
    handleSubmit,
    formState: { errors, isSubmitting, isValid },
  } = useForm({ mode: "onChange" });
  const [placeholderText, setPlaceholderText] = useState("Filter");
  const [isLoading, setIsLoading] = useState(true);
  const [dataTotal, setDataTotal] = useState(0);
  const [dataList, setDataList] = useState([]);
  const [columns, setColumns] = useState([]);
  const [networkId, setNetworkId] = useState("");
  const [keyword, setKeyword] = useState("");
  const [cpId, setCpId] = useState("");
  const [page, setPage] = useState(1);
  const countPerPage = 50;
  const [isFade, setIsFade] = useState(false);

  const openLink = (row) => {
    localStorage.setItem("service_details", JSON.stringify(row));
  };

  const [fadingRows, setFadingRows] = useState([]);

  const handleDelete = async (id, rowIndex) => {
    const dataString = { id };
    try {
      const result = await Swal.fire({
        title: `Proceed to delete this service?`,
        text: "This cannot be undone, proceed?",
        icon: "question",
        iconHtml: "?",
        showCancelButton: true,
        confirmButtonColor: "#337ab7",
        cancelButtonColor: "#ccc",
        confirmButtonText: `Yes, Proceed`,
      });
      if (result.isConfirmed) {
        setFadingRows((prev) => [...prev, id]);
        setTimeout(() => {
          setDataList((prevList) => prevList.filter((item) => item.id !== id));
        }, 500);

        const response = await fetch(API_ROUTES.DELETE_CP_SERVICES, {
          method: "POST",
          body: objectToFormData(dataString),
          headers: { token: userData?.responseDetails?.token },
        });
        const responseJSON = await response.json();

        if (responseJSON.status.toString() === "200") {
        } else {
          if (responseJSON.status.toString() === "500") {
            Swal.fire({
              title: "Error",
              text: responseJSON.required_fields,
              icon: "error",
            });
            return;
          }
          Swal.fire({
            title: "Error",
            text: responseJSON.message,
            icon: "error",
          });
        }
      }
    } catch (error) {
      if (error.response) {
        errorFunction(error);
      }
    }
  };

  const columns1 = [
    {
      name: "...",
      cell: (row, index) => {
        let names = row.serviceName.replace(/ /g, "-").toLowerCase();
        names = `${names}--${getRandomThreeDigitNumber()}${row.id}${getRandomThreeDigitNumber()}`;
        return (
          <div className="row">
            <div className="col-6 p-0">
              <Link
                to={`/edit-service/${names}`}
                onClick={() => openLink(row)}
                title="Click to Edit CP"
                className="btn"
              >
                <i className="fa fa-pencil"></i>
              </Link>
            </div>

            <div className="col-6 p-0">
              <Link
                to="#"
                onClick={() => handleDelete(row.id, index + 1)}
                title="Click to Edit CP"
                className="btn"
                style={{ color: "red" }}
              >
                <i className="fa fa-trash"></i>
              </Link>
            </div>
          </div>
        );
      },
    },
    {
      name: "Service ID",
      selector: (row) => (row.serviceId ? row.serviceId : <Nulls />),
      sortable: true,
    },
    {
      name: "Service Name",
      selector: (row) =>
        row.serviceName ? capitalizeWords(row.serviceName) : <Nulls />,
      sortable: true,
    },
    {
      name: "Network",
      cell: (row) => {
        let isNetwork = <div style={{ color: "orange" }}>MTN</div>;
        if (row.network_id === 2) {
          isNetwork = <div style={{ color: "#72ae49" }}>GLO</div>;
        } else if (row.network_id === 3) {
          isNetwork = <div style={{ color: "red" }}>AIRTEL</div>;
        } else if (row.network_id === 4) {
          isNetwork = <div style={{ color: "#82AA40" }}>9MOBILE</div>;
        }
        return (
          <>
            <b>{isNetwork}</b> &nbsp;
            <font style={{ fontSize: "14px" }}>({row.shortcode})</font>
          </>
        );
      },
    },
    {
      name: "Status",
      cell: (row) => {
        let isStatus = <div style={{ color: "orange" }}>Pending</div>;
        if (row.status === 1) {
          isStatus = <div style={{ color: "red" }}>Failed</div>;
        } else if (row.status === 2) {
          isStatus = <div style={{ color: "green" }}>Completed</div>;
        }
        return isStatus;
      },
    },
    {
      name: "Amount",
      selector: (row) =>
        row.amount ? "₦" + parseFloat(row.amount).toLocaleString() : "0.00",
    },
    {
      name: "Product Name",
      selector: (row) =>
        row.product_name ? capitalizeWords(row.product_name) : <Nulls />,
      sortable: true,
    },
  ];

  useEffect(() => {
    setColumns(columns1);
  }, []);

  const userData = JSON.parse(localStorage.getItem("userDataFs"));

  const getData = async (network = "", keyword2 = "", params = "") => {
    const filter_text1 = getValues("filter_text1");

    const dataString = {
      page: page,
      per_page: countPerPage,
      network_id: networkId,
      cp_id: cpId,
      [filter_text1]: keyword,
    };
    setIsFade(true);

    try {
      const response = await fetch(API_ROUTES.VIEW_CP_SERVICES, {
        method: "POST",
        body: objectToFormData(dataString),
        headers: { token: userData?.responseDetails?.token },
      });

      const responseJSON = await response.json();
      isAuthExpired(responseJSON); // check for expired login

      if (responseJSON.status.toString() === "200") {
        const responseData = responseJSON.data;
        setDataTotal(responseJSON.pagination.total);
        setDataList(responseData);
        setIsLoading(false);
        setIsFade(false);
      }
    } catch (error) {
      console.log("Error getting data: ", error);
      setDataTotal(0);
      setDataList([]);
      setIsLoading(false);
      setIsFade(false);
    }
  };

  useEffect(() => {
    getData("", "", "");
  }, [page]);

  const handleChange1 = async (event) => {
    const filters = event.target.value;

    setKeyword(filters);
  };

  const handleNtwk = async (event) => {
    const filters = event.target.value;
    setNetworkId(filters);
  };
  const handleCP = async (event) => {
    const filters = event.target.value;
    setCpId(filters);
  };

  const handleDropDownChange = async (event) => {
    const filters = event.target.value;
    console.log(filters);
    // return;
  };

  const watchedFilter = watch("filter_text1");
  useEffect(() => {
    if (watchedFilter) {
      setPlaceholderText(`Filter ${watchedFilter.replace("_", " ")}`);
    } else {
      setPlaceholderText("Filter");
    }
  }, [watchedFilter]);
  return (
    <>
      <Loaders />

      <div className="flapt-page-wrapper mainContent">
        <Menus />

        <div className="flapt-page-content">
          <HeaderTop />

          <div className="main-content introduction-farm mt-0">
            <div className="content-wraper-area">
              <div className="dashboard-area">
                <div className="container-fluid mb-90">
                  <div className="row g-4">
                    <div className="col-lg-12 pl-xs-0 pr-xs-0">
                      <div className="card-header mb--20 mb-xs-10">
                        <h2>Service Lists</h2>
                      </div>

                      <ServicesTable
                        capitalizeWords={capitalizeWords}
                        dataList={dataList}
                        dataTotal={dataTotal}
                        isLoading={isLoading}
                        columns={columns}
                        countPerPage={countPerPage}
                        setPage={setPage}
                        handleChange1={handleChange1}
                        isFade={isFade}
                        handleNtwk={handleNtwk}
                        handleDropDownChange={handleDropDownChange}
                        fadingRows={fadingRows}
                        isAuthExpired={isAuthExpired}
                        register={register}
                        allCPs={allCPs}
                        placeholderText={placeholderText}
                        isLoading1={isLoading1}
                        handleCP={handleCP}
                        getData={getData}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footers />
          </div>
        </div>
      </div>
    </>
  );
}
